import {
  format,
  formatDistance,
  parseISO,
  isToday,
  isYesterday,
  differenceInMinutes,
} from 'date-fns';

export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'MMM dd, yyyy');
}

export function formatTime(date: string | Date | null | undefined): string {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'HH:mm a');
}

export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'MMM dd, yyyy hh:mm a');
}

export function formatRelativeTime(date: string | Date | null | undefined): string {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return formatDistance(dateObj, new Date(), { addSuffix: true });
}

export function getDayLabel(date: string | Date | null | undefined): string {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (isToday(dateObj)) return 'Today';
  if (isYesterday(dateObj)) return 'Yesterday';
  return format(dateObj, 'EEEE, MMM dd');
}

export function calculateDuration(
  startTime: string | Date | null | undefined,
  endTime: string | Date | null | undefined
): string {
  if (!startTime || !endTime) return '0h 0m';
  const start = typeof startTime === 'string' ? parseISO(startTime) : startTime;
  const end = typeof endTime === 'string' ? parseISO(endTime) : endTime;
  let minutes = differenceInMinutes(end, start);

  // Handle overnight shifts: if negative, add 24 hours (1440 minutes)
  if (minutes < 0) {
    minutes += 1440;
  }

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h ${mins}m`;
}

export function formatDuration(minutes: number): string {
  if (!minutes || minutes < 0) return '0h 0m';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h ${mins}m`;
}
